import type React from 'react';

import { formatBytes } from '@/utils/format.utils';
import type { StorageEstimate } from '@/types/Diagnostics';

interface StorageTabProps {
  storageEstimate: StorageEstimate | null;
  percentFree: number;
}

export default function StorageTab({
  storageEstimate,
  percentFree,
}: StorageTabProps): React.JSX.Element {
  if (storageEstimate === null) {
    return <p className="text-sm text-muted-foreground">Storage estimate unavailable.</p>;
  }

  return (
    <dl className="space-y-2 text-sm">
      <div className="flex justify-between gap-4">
        <dt className="text-muted-foreground">Used</dt>
        <dd className="font-medium text-foreground">{formatBytes(storageEstimate.usageBytes)}</dd>
      </div>
      <div className="flex justify-between gap-4">
        <dt className="text-muted-foreground">Quota</dt>
        <dd className="font-medium text-foreground">{formatBytes(storageEstimate.quotaBytes)}</dd>
      </div>
      <div className="flex justify-between gap-4">
        <dt className="text-muted-foreground">Free</dt>
        <dd className="font-medium text-foreground">{percentFree}%</dd>
      </div>
    </dl>
  );
}
